export default __webpack_public_path__ + "c3f3ed50ee10d157fe8e779aedcf38b1.svg";